import { CandidateHandicapCase } from '@flex-apis/recruiting';
import type { SelectProps } from '@flex-design-system/fx';
import { Select } from '@flex-design-system/fx';
import { Translation } from '@flex-packages/i18n';

import { DISABLED_TYPE_CONTENT, isCandidateHandicapCase } from '../../base';

interface DisabledTypeSelectProps extends SelectProps {
  disabledType?: CandidateHandicapCase;
  onDisabledTypeChange: (newDisabledType: CandidateHandicapCase) => void;
}

const DISABLED_TYPES: Array<CandidateHandicapCase> = [
  CandidateHandicapCase.Unknown,
  CandidateHandicapCase.Normal,
  CandidateHandicapCase.IndustrialAccident,
  CandidateHandicapCase.VeteransDisability,
  CandidateHandicapCase.Etc,
];

function DisabledTypeSelect({
  children,
  disabledType,
  onDisabledTypeChange,
  ...props
}: DisabledTypeSelectProps) {
  return (
    <Select
      {...props}
      value={disabledType}
      onValueChange={value => {
        if (!isCandidateHandicapCase(value)) {
          return;
        }
        onDisabledTypeChange(value);
      }}
    >
      <Select.Trigger asChild>{children}</Select.Trigger>
      <Select.Content onCloseAutoFocus={e => e.preventDefault()}>
        {DISABLED_TYPES.map(type => (
          <Select.Option key={type} value={type}>
            <Select.OptionTitle>
              <Translation tKey={DISABLED_TYPE_CONTENT[type].i18n} />
            </Select.OptionTitle>
          </Select.Option>
        ))}
      </Select.Content>
    </Select>
  );
}

export default DisabledTypeSelect;
